import * as $ from 'jquery';

export default function initTabs() {
	function switchTab(event: Event) {
		event.preventDefault();
		const $this = $(this);
		var href = $this.attr('href');
		var hash = $(this).attr('href').split('#')[1];
		var $tabTargets = $('.product__tabs').find('a[id]');
		$tabTargets.removeClass('active').filter('[id="'+hash+'"]').addClass('active');
	}

	const tabEl: NodeList = document.querySelectorAll('a[role="tab"]');
	for (let i: number = 0; i < tabEl.length; i++) {
		const element: Node = tabEl[i];
		element.addEventListener('click', switchTab);
	}
}
